import { ConsumerPropertyName, EndpointPropertyName, EndpointType } from '../../common/types/EndpointType';
import { CommonTableCell, ConsumerTableCell, DomainTableCell, SourceTableCell } from '../components/TableCell';
import { ColumnProperties } from '../types/Column';

export const getEndpointsProperty = (domain: EndpointType, property: Exclude<EndpointPropertyName, 'consumers'>) =>
  domain.endpoints.map((endpoint) => endpoint[property]);

export const getConsumerProperty = (domain: EndpointType, property: ConsumerPropertyName) =>
  domain.endpoints.map((endpoint) => endpoint.consumers.map((consumer) => consumer[property]));

export const COLUMNS: ColumnProperties[] = [
  {
    name: 'DOMAIN',
    width: 100,
    disabled: true,
    checked: true,
    filterDisabled: false,
    getValues: (data: EndpointType) => data.name,
    getAdditionalValues: (data: EndpointType) => data.process,
    domainCellComponent: DomainTableCell
  },
  {
    name: 'SERVICE NAME',
    width: 300,
    disabled: true,
    checked: true,
    filterDisabled: true,
    getValues: (data: EndpointType) => getEndpointsProperty(data, 'description'),
    cellComponent: CommonTableCell
  },
  {
    name: 'TECHNICAL SERVICE NAME',
    width: 300,
    checked: false,
    filterDisabled: false,
    getValues: (data: EndpointType) => getEndpointsProperty(data, 'service'),
    cellComponent: CommonTableCell
  },
  {
    name: 'TYPE',
    width: 150,
    checked: true,
    filterDisabled: false,
    getValues: (data: EndpointType) => getEndpointsProperty(data, 'type'),
    cellComponent: CommonTableCell
  },
  {
    name: 'METHOD',
    width: 100,
    disabled: false,
    checked: false,
    filterDisabled: false,
    getValues: (data: EndpointType) => getEndpointsProperty(data, 'method').map((method) => method || '-'),
    cellComponent: CommonTableCell
  },
  {
    name: 'ENDPOINT NAME',
    width: 250,
    checked: false,
    filterDisabled: true,
    getValues: (data: EndpointType) => getEndpointsProperty(data, 'endpoint'),
    cellComponent: CommonTableCell
  },
  {
    name: 'SOURCE',
    width: 100,
    checked: true,
    filterDisabled: false,
    getValues: (data: EndpointType) => getEndpointsProperty(data, 'sources'),
    cellComponent: SourceTableCell
  },
  {
    name: 'NUMBER OF CONSUMER',
    width: 100,
    checked: true,
    filterDisabled: true,
    getValues: (data: EndpointType) => getEndpointsProperty(data, 'numberOfConsumer'),
    cellComponent: CommonTableCell
  },
  {
    name: 'CONSUMER',
    width: 300,
    checked: true,
    filterDisabled: true,
    getValues: (data: EndpointType) => getConsumerProperty(data, 'name'),
    cellComponent: ConsumerTableCell
  },
  {
    name: 'CONSUMPTION VOLUME (YTD)',
    width: 200,
    checked: true,
    filterDisabled: true,
    getValues: (data: EndpointType) => getConsumerProperty(data, 'volume'),
    cellComponent: ConsumerTableCell
  }
];
